import presetThemes from './theme';
import { registerTheme } from './core/theme';

presetThemes.forEach(theme => {
  registerTheme(theme);
});
